import React, { FC } from 'react';
import cls from './Loader.module.css';
import classNames from 'classnames';

export const Loader = ({}) => {
    return (
        <div className={classNames(cls.ldsEllipsis)}>
            <div />
            <div />
            <div />
            <div />
        </div>
    );
};
